import { Seo } from "@/components/site/Seo";
import { Hero } from "@/components/site/Hero";
import { PageShell } from "@/components/site/PageShell";
import { CtaBand, FaqAccordion } from "@/components/sections/Sections";
import { GENERAL_FAQ } from "@/data/content";
import { SERVICES } from "@/data/services";
import { breadcrumbLd, faqLd } from "@/lib/jsonld";

const GROUPS = [{ id: "allgemein", title: "Allgemeine Fragen", items: GENERAL_FAQ }, ...SERVICES.map((s) => ({ id: s.slug, title: s.name, items: s.faq }))];
const crumbs = [{ label: "FAQ", to: "/faq" }];

export default function FaqPage() {
  return (
    <>
      <Seo
        title="FAQ: Häufige Fragen zum Kfz-Gutachten Köln | Marcone"
        description="Häufige Fragen zum Kfz-Gutachten: Wer zahlt, wie schnell geht es, welche Rechte haben Sie nach dem Unfall? Antworten vom TÜV-zertifizierten Gutachter in Köln."
        path="/faq"
        jsonLd={[faqLd(GROUPS.flatMap((g) => g.items)), breadcrumbLd(crumbs)]}
      />
      <PageShell
        hero={
          <Hero
            image="hero-haftpflicht"
            imageAlt="Unfallstelle mit Warndreieck auf einer Kölner Straße am Abend"
            eyebrow="FAQ"
            title="Häufige Fragen zum Kfz-Gutachten"
            subtitle="Kosten, Ablauf, Ihre Rechte – die wichtigsten Antworten auf einen Blick."
            breadcrumbs={crumbs}
          />
        }
      >
        <nav aria-label="Themen" className="mb-10 flex flex-wrap gap-2">
          {GROUPS.map((g) => (
            <a key={g.id} href={`#${g.id}`} className="rounded-full bg-brand-mist px-4 py-2 text-sm font-semibold text-brand-anthracite transition-colors hover:bg-brand-sky-light hover:text-brand-blue" data-testid={`faq-topic-${g.id}`}>
              {g.title}
            </a>
          ))}
        </nav>
        <div className="space-y-14">
          {GROUPS.map((g) => (
            <section key={g.id} id={g.id} className="scroll-mt-28">
              <h2 className="h2-brand mb-6 text-2xl">{g.title}</h2>
              <FaqAccordion items={g.items} prefix={`faq-${g.id}`} />
            </section>
          ))}
          <CtaBand prefix="faq-cta" />
        </div>
      </PageShell>
    </>
  );
}
